import { createGlobalStyle } from 'styled-components'
import {
  mediaMax,
  calculateResponsiveSize,
  calculateMobileResponsiveSize
} from 'styles/media-queries'

const GlobalStyle = createGlobalStyle`
  :root {
    --black: #7C7D7F;
    --white: #FFFFFF;
  }
  html, body{
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    font-size: 14px;
    color: #7C7D7F;
    line-height: 1.25;
    background: #ffffff;
    min-width: 320px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  body{
    overflow-y: scroll;
  }
  body.hidden {
    height: 100dvh !important;
  }
  body.hidden .home-wrapper {
    height: 100dvh;
    overflow: hidden;
  }
  html, body, A, input, select, textarea, button{
    font-family: 'Helvetica Neue LT Pro', Arial, Tahoma, Geneva, Kalimati, sans-serif;
  }
  A{
    text-decoration: none;
    color: #7C7D7F;
    transition: all 0.25s ease 0s;
    outline: none;
  }
  A:hover{
    text-decoration: underline;
  }
  input, select, textarea {
    vertical-align: top;
    outline: none;
  }
  /* ----- Safari profile icon ----- */
  input::-webkit-contacts-auto-fill-button {
    visibility: hidden;
    display: none !important;
    pointer-events: none;
    position: absolute;
    right: 0;
  }
  textarea {
    resize: vertical;
  }
  *{ -webkit-tap-highlight-color: transparent; box-sizing: border-box; }
  img, object, iframe, svg{ border: 0; vertical-align: top; }
  svg path, svg circle, svg line{ transition: all 0.25s ease 0s; }
  button { font-weight: 400; }
  .home-content {
    will-change: transform; 
  }
  /* ----- react-select ----- */
  @keyframes selectSlideInOut {
    0% {
      transform: translateY(-1px);
    }
    100% {
      transform: translateY(0);
    }
  }

  /* ----- For br ----- */
  .for-mobile {
    display: none;
  }
  ${mediaMax('mobile')} {
    .for-desktop {
      display: none;
    }
    .for-mobile {
      display: inline;
    }
  }

  /* ----- Animations ----- */
  .fadeIn {
    /* transform: translateY(100px); */
    opacity: 0;
    transition: transform 1s, opacity 1s;
    &.visible {
      /* transform: translateY(0); */
      opacity: 1;
    }
  }

  /* ----- UserWay ----- */
  body .uwy {
    opacity: 1;
    visibility: visible;
    transition: opacity 2s, visibility 2s;
    z-index: 50 !important;
    &.hide {
      opacity: 0;
      visibility: hidden;
      transition: opacity 0s, visibility 0s;
    }
  }
  body .uwy > .userway_buttons_wrapper  {
    top: auto !important;
    bottom: ${calculateResponsiveSize(36)} !important;
    right: ${calculateResponsiveSize(42)} !important;
    left: auto !important;
    transform: none !important;
    ${mediaMax('mobile')} {
      bottom: ${calculateMobileResponsiveSize(24)} !important;
      right: ${calculateMobileResponsiveSize(24)} !important;
    }
  }
  body .uwy .uai, body .uwy .uai > span {
    width: ${calculateResponsiveSize(40)} !important;
    height: ${calculateResponsiveSize(40)} !important;
    ${mediaMax('mobile')} {
      width: ${calculateMobileResponsiveSize(30)} !important;
      height: ${calculateMobileResponsiveSize(30)} !important;
    }
  }
  body .uwy .uai > span > img {
    width: 100% !important;
    height: auto !important;
  }

  /* ----- For gallery ----- */
  .portal {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 103;
    display: flex;
    justify-content: center;
  }
`

export default GlobalStyle
